import { render, staticRenderFns } from "./SbpsSubmitForm.vue?vue&type=template&id=6b3f0b73&"
import script from "./SbpsSubmitForm.vue?vue&type=script&lang=js&"
export * from "./SbpsSubmitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports